"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageUploaderContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

var ImageUploaderContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  color: var(--magenta-main, #e33aa9);\n  text-align: center;\n  font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  padding: 49px 32px;\n  & > div {\n    & > p {\n      margin-bottom: 10px;\n    }\n    & > span {\n      color: var(--grey-medium, #cbcbcb);\n      font-size: 10px;\n      font-weight: 400;\n    }\n  }\n"])));

exports.ImageUploaderContainer = ImageUploaderContainer;